import { SDInputPulseOverrides } from '../SDInput/styled-components'

export const pulseDatePickerOverrides = {
  Input: {
    props: {
      overrides: SDInputPulseOverrides(),
    },
  },
}
